module.exports = __webpack_public_path__ + "img/ltkover40-1x.b6fafc3.jpg";